import React, { ReactNode } from 'react';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
}

export function GlassCard({ children, className = '' }: GlassCardProps) {
  return (
    <div className={`bg-gray-900/50 backdrop-blur-xl border border-cyan-300/20 rounded-2xl shadow-lg shadow-black/20 ${className}`}>
      {children}
    </div>
  );
}